import { fetchPublicSamples } from 'src/api/samples';

const { createAsyncThunk } = require('@reduxjs/toolkit');

export const getPublicSamples = createAsyncThunk('publicSamples/getPublicSamples', async () => {
  const response = await fetchPublicSamples();
  return response.data;
});
